import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';

export const GetAnalyzeSurvey = 'GET_ANALYZE_SURVEY';

export const useGetAnalyzeSurvey = (id: number) => {
  const { fetchAnalyzeSurvey } = useServicesContext();
  return useQuery({
    queryKey: [GetAnalyzeSurvey, id],
    queryFn: () => fetchAnalyzeSurvey(id),
  });
};
